export default __webpack_public_path__ + "static/media/image1.4e9d1cf8.png";